import {Injectable} from '@angular/core';
import {GenericServicesMotoristaService} from './generic-services-motorista.service';
import {MensagensService} from 'max-ng-lib';
import {HttpClient} from '@angular/common/http';
import {ParametroModel} from '../content/pages/components/configuracoes/parametros/parametro.model';
import {enumTipoParametro} from '../core/enums/enums';
import {Observable} from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class ParametroDispositivoService extends GenericServicesMotoristaService {

	constructor(private _mensagensService: MensagensService,
				private _httpClient: HttpClient) {
		super();
	}

	getMensagensService(): MensagensService {
		return this._mensagensService;
	}

	getHttpClient(): HttpClient {
		return this._httpClient;
	}

	getUrlRecurso(): string {
		return '/parametroDispositivo';
	}

	salvarParametros(parametroModel: ParametroModel) {
		this.obrigarBaterHorarioReceicao().subscribe(value => {
			console.log(value);
		});
		return this.post<ParametroModel>('/salvar', {dados: parametroModel});


	}

	listarParametrosDispositivo(tipoParametro: string = enumTipoParametro.FILIAL) {
		return this.get<ParametroModel[]>(`/listar-parametros-dispositivo/${tipoParametro}`);
	}

	obrigarBaterHorarioReceicao() {
		return this.get<ParametroModel>('/obrigarBaterHorarioRefeicao');
	}

	utilizaMaxPag() {
		return this.get<ParametroModel>('/utilizaMaxPag');
	}

	visualizacaoRomaneioApk() {
		return this.get<ParametroModel>('/visualizacaoRomaneioApk');
	}

	listarParametrosDispositivoPersonalizado(filtro: any) {
		return this.post<ParametroModel[]>(`/listarParametrosDispositivoPersonalizado`, {
			dados: filtro
		});
	}

	atualizarTipoParametro(parametroTipoAtualizar: any) {
		return this.post<ParametroModel[]>(`/atualizarTipoParametro`, {
			dados: parametroTipoAtualizar
		});
	}

	buscarParametroEspecifico(parametro) {
		return this.get<ParametroModel>(`/buscarParametroEspecifico/${parametro}`);
	}

	utilizaParametroBaixarTituloMaxPag(): Observable<boolean> {
		return this.get<boolean>('/utilizaParametroBaixarTituloMaxPag');
	}
}
